module.exports = __webpack_public_path__ + "img/money.f9195cef.png";